import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted fonts — bundled into the build so they load under the strict
// production CSP (font-src 'self'). Replaces the remote Google Fonts @import,
// which the CSP blocked when served via nginx (Docker), collapsing the UI to
// system fonts. Weights mirror the original @import.
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource/source-serif-4/400.css'
import '@fontsource/source-serif-4/500.css'
import '@fontsource/source-serif-4/600.css'
import '@fontsource/source-serif-4/700.css'
import '@fontsource/source-serif-4/800.css'

import './index.css'
import App from './App.jsx'
import { applySerifFont, getSerifFont } from './utils/fontPreference'

applySerifFont(getSerifFont())

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
